export const EVALUATOR_HEADER_MOBILE_BREAKPOINT = 1100;
export const EVALUATOR_DATE_SELECTOR_COMPACT_WIDTH = 280;

export const isEvaluatorHeaderMobile = (windowWidth) => {
  return Number.isFinite(windowWidth) && windowWidth < EVALUATOR_HEADER_MOBILE_BREAKPOINT;
};

export const isEvaluatorDateSelectorCompact = (containerWidth) => {
  return Number.isFinite(containerWidth) && containerWidth > 0 && containerWidth < EVALUATOR_DATE_SELECTOR_COMPACT_WIDTH;
};
